import { ChoiceRow } from './ui';

/**
 * The Dashboard's "Add Property" choices (UI-GLASS1, the 132nd): the first of the two pop-ups a phone shows that offer a
 * short list of choices, drawn as iOS 26 draws a menu - pill rows on the frosted panel. ⛔ The words and what each row
 * does are exactly what they were; the form that follows "Enter Manually" is a form and keeps the card look.
 */
export default function AddPropertyChoices({ onUpload, onManual }: { onUpload: () => void; onManual: () => void }) {
  return (
    <div className="space-y-2">
      <ChoiceRow
        label="Upload a Document"
        hint="Upload a PDF and auto-extract property data"
        onClick={onUpload}
        icon={
          <svg className="h-6 w-6 text-primary-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" />
          </svg>
        }
      />
      <ChoiceRow
        label="Enter Manually"
        hint="Type in property details by hand"
        onClick={onManual}
        icon={
          <svg className="h-6 w-6 text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
          </svg>
        }
      />
    </div>
  );
}
